import {Injectable, EventEmitter}     from 'angular2/core';

@Injectable()
export class AlertService {

    private emiter:EventEmitter<any> = new EventEmitter();

    pushAlert(alert:Object) {
        this.emiter.emit(alert);
    }

    getChangeEmitter() { return this.emiter; }

}